<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">Shipping</h2>
      <br />
      <el-button style="float: right; margin-right: 30px" @click="Create()">Create</el-button>
    </el-row>
    <br />
    <el-card>
      <el-row>
        <el-form :inline="true" :model="query" :label-position="'top'" class="demo-form-inline">
          <el-col>
            <el-form-item label="macAddress">
              <the-mask class="el-input__inner" v-model="query.macAddress" :masked="true" mask="FF:FF:FF:FF:FF:FF"
                @input="sanitize($event)" @keyup.enter.native="load" :tokens="hexTokens" />
            </el-form-item>
            <el-form-item label="Partner" prop="partner">
              <el-select v-model="query.partner" placeholder="Select" filterable clearable @change="load">
                <el-option v-for="item in partnerSelect" :key="item.key" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>

        <el-col>
          <el-button type="primary" @click="
            query.page = 1;
          load();
          ">Filter</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination layout="prev, pager, next,sizes" :total="searchResult.total" :page-sizes="pageSizes"
            :page-size.sync="query.pageSize" :current-page.sync="query.page" @current-change="load"
            @size-change="load"></el-pagination>
          <!-- Table -->
        </el-col>
        <el-col>
          <el-table v-loading="loading" :data="searchResult.shippings" class="border">
            <el-table-column type="index" width="50" />
            <el-table-column prop="createdAt" label="Create At" />
            <el-table-column prop="shippingName" label="Name" />
            <el-table-column prop="type" label="Type" />
            <el-table-column prop="partner.name" label="Partner" />
            <el-table-column prop="totalHardwares" label="Total Hardware" width="150px;" />
            <el-table-column prop="status" label="Status" width="150px;" />
            <el-table-column label="Actions" width="200px">
              <template slot-scope="scope">
                <el-button size="mini" icon="el-icon-view" @click="Edit(scope.row, true)"></el-button>
                <el-dropdown style="margin-left: 12px" @command="handleCommand" v-if="
                  scope.row.status != 'COMPLETED' &&
                  scope.row.status != 'CANCELLED'
                ">
                  <span class="el-dropdown-link">
                    Options<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{ scope: scope.row, event: 'EDIT' }">Edit</el-dropdown-item>
                    <el-dropdown-item :command="{ scope: scope.row, event: 'COMPLETED' }">COMPLETED</el-dropdown-item>
                    <el-dropdown-item :command="{ scope: scope.row, event: 'CANCELLED' }">CANCELLED</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button v-if="
                  scope.row.status == 'COMPLETED' &&
                  scope.row.type == 'outGoing'
                " size="mini" @click="printPage(scope.row)">PRINT</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>

        <el-col :span="24" style="text-align: right">
          <el-pagination layout="prev, pager, next,sizes" :total="searchResult.total" :page-sizes="pageSizes"
            :page-size.sync="query.pageSize" :current-page.sync="query.page" @current-change="load"
            @size-change="load"></el-pagination>
          <!-- Table -->
        </el-col>
      </el-row>
    </el-card>
    <el-dialog width="70%" title="Create Shipping" :visible.sync="showForm">
      <el-form ref="form" :model="form" v-loading="formLoading" label-width="130px">
        <el-form-item label="Name" prop="shippingName">
          <el-input placeholder="Please input" v-model="shippingName"></el-input>
        </el-form-item>
        <el-form-item label="Shipping type" prop="type">
          <el-switch v-model="form.type" active-value="outGoing" inactive-value="inComming" active-text="outGoing"
            inactive-text="inComming">
          </el-switch>
        </el-form-item>
        <el-form-item :label="this.form.type == 'outGoing' ? 'To Partner' : 'From Partner'" prop="partner">
          <el-select v-model="form.partner" placeholder="Select" clearable filterable value-key="_id">
            <el-option v-for="item in partnerSelect" :key="item.key" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Mac Address" prop="macAddress">
          <el-select v-model="form.hardwares" placeholder="Select" clearable filterable remote
            :remote-method="remoteMethod" :loading="remoteMacAddressLoading">
            <el-option-group v-for="hardware in remoteMacAddress" :key="hardware.label" :label="hardware.label">
              <el-option v-for="item in hardware.data" :key="item.macAddress" :label="item.macAddress"
                :value="item"></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-table v-loading="loading" :data="hardwareTable" class="border">
            <el-table-column type="index" width="50" />
            <el-table-column prop="macAddress" label="macAddress" width="150px;" />
            <el-table-column prop="version" label="Version" width="100px;" />
            <el-table-column prop="versionRequestedAt" label="Version Requested At" width="200px;" />
            <el-table-column label="Actions" width="100px">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="deleteHardware(scope.row)">Delete</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="CreateShipping()">Create</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog width="70%" :title="`${form.seeSummary ? 'Summary' : 'Edit Shipping'}`" :visible.sync="editShowform">
      <el-form ref="form" :model="form" v-loading="formLoading" label-width="130px">
        <el-form-item label="shippingName" prop="shippingName">
          <el-input :disabled="form.seeSummary" placeholder="Please input" v-model="shippingName"></el-input>
        </el-form-item>
        <el-form-item label="Shipping type" prop="partner">
          <el-switch :disabled="form.seeSummary" :value="form.type" active-value="outGoing" inactive-value="inComming"
            active-text="outGoing" inactive-text="inComming">
          </el-switch>
        </el-form-item>
        <el-form-item :label="this.form.type == 'outGoing' ? 'To Partner' : 'From Partner'" prop="partner">
          <el-select :disabled="form.seeSummary" v-model="form.partner" placeholder="Select" clearable filterable
            value-key="_id">
            <el-option v-for="item in partnerSelect" :key="item.key" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Mac Address" prop="macAddress">
          <el-select :disabled="form.seeSummary" v-model="form.hardwares" placeholder="Select" clearable filterable
            remote :remote-method="remoteMethod" :loading="remoteMacAddressLoading">
            <el-option-group v-for="hardware in remoteMacAddress" :key="hardware.label" :label="hardware.label">
              <el-option v-for="item in hardware.data" :key="item.macAddress" :label="item.macAddress"
                :value="item"></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-table v-loading="loading" :data="hardwareTable" class="border">
            <el-table-column type="index" width="50" />
            <el-table-column prop="macAddress" label="macAddress" width="150px;" />
            <el-table-column prop="version" label="Version" width="100px;" />
            <el-table-column prop="versionRequestedAt" label="Version Requested At" width="200px;" />
            <el-table-column v-if="!form.seeSummary" label="Actions" width="100px">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="deleteHardware(scope.row)">Delete</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item>
          <el-button v-if="!form.seeSummary" type="primary" @click="UpdateShipping()">Save</el-button>
          <el-button @click="Cancel()">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog width="70%" title="Print Shipping" :visible.sync="printShowform">
      <el-form ref="form" :model="printForm" v-loading="formLoading" label-width="130px" v-if="!previewShowForm">
        <el-row>
          <el-form-item label="Language:">
            <el-col>
              <el-radio v-model="printForm.language" label="en" border>English</el-radio>
              <el-radio v-model="printForm.language" label="tr" border>Turkish</el-radio>
            </el-col>
          </el-form-item>
          <el-form-item label="Fax:">
            <el-input size="mini" placeholder="Please input fax Number" v-model="printForm.fax"></el-input>
          </el-form-item>
          <el-form-item label="Attention To:">
            <el-input size="mini" placeholder="Please input Attention To" v-model="printForm.attentionTo"></el-input>
          </el-form-item>
          <el-form-item label="Po Number:">
            <el-input size="mini" placeholder="Please input Po Number" v-model="printForm.poNumber"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col>
            <h3>Total Measurement of package</h3>
          </el-col>
        </el-row>
        <el-row style="left: 50px; width: 100%">
          <el-form-item label="Sensors:" label-width="150px;">
            <el-col :span="4" v-for="description of prePrintValue.hardwareType" :key="description.name">
              {{ description.name.toUpperCase() }}: {{ description.value }}
            </el-col>
          </el-form-item>
        </el-row>
        <el-form-item label="Add Goods">
          <el-button size="mini" @click="addItem()">Add</el-button>
        </el-form-item>
        <el-table v-loading="loading" :data="printForm.items" class="border" :max-height="500">
          <el-table-column type="index" width="50" />
          <el-table-column prop="description" label="Description of Goods" width="200px;">
            <template slot-scope="scope">
              <el-input placeholder="Please input goods" v-model="scope.row.description"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="quantity	" label="Quantity" width="200px;">
            <template slot-scope="scope">
              <el-input-number placeholder="Please input quantity" @change="changeTotalWeight()"
                v-model="scope.row.quantity" :controls="false"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="unit" label="Unit" width="200px;">
            <template slot-scope="scope">
              <el-input placeholder="Please input goods" v-model="scope.row.unit"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="netWeight" label="Net Weight(Gram)" width="200px;">
            <template slot-scope="scope">
              <el-input-number placeholder="Please input Net Weight" v-model="scope.row.netWeight"
                :controls="false"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="grossWeight" label="Gross Weight(Gram)" width="200px;">
            <template slot-scope="scope">
              <el-input-number placeholder="Please input Gross Weight" v-model="scope.row.grossWeight"
                @change="changeTotalWeight()" :controls="false"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="Actions" width="100px">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="deleteGoods(scope.row)">Delete</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="5">
            <el-form-item label="Length: " prop="length">
              <el-input size="small" placeholder="Please input length" v-model="printForm.length">
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Width: " prop="width">
              <el-input size="small" placeholder="Please input width" v-model="printForm.width">
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Height: " prop="height">
              <el-input size="small" placeholder="Please input height" v-model="printForm.height">
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="Total Gross Weight:" label-width="150px;">
              <el-input size="small" style="width: 150px" placeholder="Please input TotalGrossWeight"
                v-model="printForm.TotalGrossWeight">
                <template slot="append">gr</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" @click="previewDocument()">Preview for Print</el-button>
          <el-button @click="Cancel()">Cancel</el-button>
        </el-form-item>
      </el-form>
      <ShippingCargo id="printArea" v-show="previewShowForm" :form="prePrintValue" :printForm="printForm"
        :partnerData="partnerData" @created="previewShowForm = false" @canceled="previewShowForm = false">
      </ShippingCargo>
      <el-button style="margin-top: 40px" v-show="previewShowForm" type="primary" @click="printNow()">
        Print</el-button>
      <el-button v-show="previewShowForm" @click="previewShowForm = !previewShowForm">Cancel</el-button>
    </el-dialog>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import { TheMask } from "vue-the-mask";
import axios from "axios";
import { url } from "../service/url";
import queryStringUtil from "query-string";
import ShippingCargo from "./Shipping_Cargo";
import dayjs from "dayjs";
export default {
  name: "Shipping",
  components: { TheMask, ShippingCargo },
  data() {
    return {
      hexTokens: {
        F: {
          pattern: /[0-9a-fA-F]/,
          transform: (v) => v.toLocaleUpperCase(),
        },
      },
      query: {
        macAddress: "",
        partner: "", // Burası production için değişecek,
        page: 1,
        pageSize: 10,
      },
      pageSizes: [10, 25, 50, 75],
      remoteMacAddress: [],
      certs: {},
      showCertsForm: false,
      editId: "",
      editShowform: false,
      printShowform: false,
      previewShowForm: false,
      partnerData: "",
      printFormIndex: 0,
      prePrintValue: {
        gateway: 3,
      },
      printForm: {
        items: [
          {
            index: 0,
            description: "",
            quantity: 0,
            unit: "",
            netWeight: 0,
            grossWeight: 0,
          },
        ],
        TotalGrossWeight: 0,
        length: 0,
        width: 0,
        height: 0,
        language: "en",
      },
      showForm: false,
      formLoading: false,
      shippingName: "",
      form: {
        type: "outGoing",
        partner: "",
        hardwares: "",
      },
      hardwareTable: [],
      remoteMacAddressLoading: false,
    };
  },
  created() {
    this.getShippings(this.query); // Burası production için değişecek
    this.getPartners();
  },
  computed: {
    ...mapState("shipping", ["searchResult", "loading"]),
    ...mapState("partner", ["partners"]),

    partnerSelect() {
      return this.partners.map((x) => {
        return {
          value: x,
          label: x.name,
          key: x._id,
        };
      });
    },
  },
  methods: {
    printNow() {
      // Get HTML to print from element
      const prtHtml = document.getElementById("printArea").innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`);
      WinPrint.document.title = `${this.partnerData[0]}_${dayjs().format(
        "DD-MM-YYYY HH:mm:ss"
      )}`;
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      this.sendMailShippings({
        form: this.prePrintValue,
        printForm: this.printForm,
        partnerData: this.partnerData,
      });
    },

    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async resizeImage(base64Str, maxWidth, maxHeight) {
      return new Promise((resolve) => {
        let img = new Image();
        img.src = base64Str;
        img.onload = () => {
          let canvas = document.createElement("canvas");
          // const MAX_WIDTH = maxWidth;
          const MAX_HEIGHT = maxHeight;
          let width = img.width;
          let height = img.height;
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
          canvas.width = width;
          canvas.height = height;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL());
        };
      });
    },
    addItem() {
      this.printForm.items.push({
        index: ++this.printFormIndex,
        description: "",
        quantity: 0,
        unit: "",
        netWeight: 0,
        grossWeight: 0,
      });
    },
    previewDocument() {
      this.previewShowForm = true;
    },
    changeTotalWeight() {
      let totalWeight = 0;
      this.printForm.items.forEach((element) => {
        totalWeight = totalWeight + element.grossWeight * element.quantity;
      });
      this.printForm.TotalGrossWeight = totalWeight;
    },
    handleCommand(command) {
      switch (command.event) {
        case "EDIT":
          this.Edit(command.scope, false);
          break;
        case "COMPLETED":
          this.UpdateShippingStatus(command.scope, "COMPLETED");
          break;
        case "CANCELLED":
          this.UpdateShippingStatus(command.scope, "CANCELLED");
          break;
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.remoteMacAddressLoading = true;
        axios
          .get(
            `${url}/partner-shipping/search?${this.queryString({
              macAddress: query,
              partner: this.form.partner._id,
              type: this.form.type,
            })}`
          )
          .then((req) => {
            this.remoteMacAddress = req.data.hardwares;
            this.remoteMacAddressLoading = false;
          })
          .catch((err) => {
            this.$message.error(err.response.data.message);
          });
      } else {
        this.options = [];
      }
    },
    queryString(query) {
      var queryParams = {
        macAddress: query.macAddress,
        partner: query.partner,
        type: query.type,
      };
      return queryStringUtil.stringify(queryParams, {
        arrayFormat: "bracket",
      });
    },
    sanitize(value) {
      this.form.macAddress = value.trim().toUpperCase();
    },
    ...mapActions("shipping", [
      "getShippings",
      "createShipping",
      "updateShipping",
      "sendMailShippings",
    ]),
    ...mapActions("partner", ["getPartners"]),
    adviseSystemAdmin() {
      this.$message.info("advise to the system admin");
    },
    copyIdToClipboard(id) {
      this.$clipboard(id);
      this.$message.info("'" + id + "' " + "copy to clipboard success");
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    CreateShipping() {
      if (this.form.type && this.form.partner) {
        this.formLoading = true;
        if (this.form.type == "inComming") {
          this.$confirm(
            `Do you want to confirm income shipping?. Continue?!!!`,
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          )
            .then(() => {
              this.createShipping({
                name: this.shippingName,
                type: this.form.type,
                hardwares: this.hardwareTable,
                partner: this.form.partner._id,
              })
                .then(() => {
                  this.showCertsForm = true;
                  this.formLoading = false;
                  this.showForm = false;
                })
                .finally(() => {
                  this.formLoading = false;
                  this.load();
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: `to income shipping canceled`,
              });
            });
        } else {
          this.createShipping({
            name: this.shippingName,
            type: this.form.type,
            hardwares: this.hardwareTable,
            partner: this.form.partner._id,
          })
            .then(() => {
              this.showCertsForm = true;
              this.formLoading = false;
              this.showForm = false;
            })
            .finally(() => {
              this.formLoading = false;
              this.load();
            });
        }
      } else {
        this.$message({
          type: "info",
          message: "Please enter partner",
        });
      }
    },
    load() {
      this.getShippings(this.query);
    },
    UpdateShipping() {
      this.updateShipping({
        _id: this.editId,
        name: this.shippingName,
        type: this.form.type,
        partner: this.form.partner._id,
        hardwares: this.hardwareTable,
      })
        .then(() => {
          this.showForm = false;
          this.editShowform = false;
        })
        .finally(() => {
          this.editId = "";
          this.load(this.query);
        });
    },
    UpdateShippingStatus(scope, newStatus) {
      console.log("Geldi", newStatus);
      this.$confirm(
        `Do you want to change status to ${newStatus}. Continue?!!!`,
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.updateShipping({
            _id: scope._id,
            partner: scope.partner._id,
            newStatus: newStatus,
          });
        })
        .then(() => {
          this.load();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `to change status to ${newStatus} canceled`,
          });
        });
    },
    Create() {
      this.editId = undefined;
      this.showForm = true;
      this.shippingName = "";
      this.form = {
        type: "outGoing",
        partner: "",
        hardwares: "",
        seeSummary: false,
      };
      this.hardwareTable = [];
    },
    Cancel() {
      this.editId = "";
      this.shippingName = ";";
      this.form = {
        type: "outGoing",
        partner: "",
        hardwares: "",
        seeSummary: false,
      };
      this.hardwareTable = [];
      this.editShowform = false;
      this.showForm = false;
      this.printShowform = false;
      this.printForm = {
        items: [
          {
            index: 0,
            description: "",
            quantity: 0,
            unit: "",
            netWeight: 0,
            grossWeight: 0,
          },
        ],
        language: "en",
        TotalGrossWeight: 0,
        length: 0,
        width: 0,
        height: 0,
      };
    },
    printPage(scope) {
      this.prePrintValue = scope;
      const countOccurrences = (arr) => {
        return arr.reduce(
          (prev, curr) => ((prev[curr] = ++prev[curr] || 1), prev),
          {}
        );
      };
      let variationHardware = this.prePrintValue.hardwares.map((x) => {
        return x.deviceType;
      });
      let arr = [];
      for (const [key, value] of Object.entries(
        countOccurrences(variationHardware)
      )) {
        arr.push({ name: key, value: value });
      }
      this.prePrintValue.hardwareType = arr;
      this.printShowform = true;
    },
    deleteHardware(scope) {
      let index = this.hardwareTable.findIndex((x) => x._id == scope._id);
      this.hardwareTable.splice(index, 1);
    },
    deleteGoods(scope) {
      let index = this.printForm.items.findIndex((x) => x.index == scope.index);
      this.printForm.items.splice(index, 1);
    },
    Edit(scope, seeSummary) {
      this.shippingName = scope.shippingName;
      this.form = {
        type: scope.type,
        partner: scope.partner,
        hardwares: "",
        seeSummary: seeSummary
      };
      this.hardwareTable = scope.hardwares;
      this.editId = scope._id;
      this.editShowform = true;
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  watch: {
    "form.hardwares"() {
      let newhardware = this.hardwareTable.filter(
        (x) => x.macAddress == this.form.hardwares.macAddress
      );
      if (this.form.hardwares != "" && !newhardware.length) {
        this.hardwareTable.push(this.form.hardwares);
        this.form.hardwares = "";
      }
    },
    previewShowForm() {
      if (this.previewShowForm == true) {
        axios
          .get(`${url}/partner/${this.prePrintValue.partner}`)
          .then((resp) => {
            return [
              resp.data.name,
              resp.data.address,
              resp.data.phone,
              this.printForm.fax,
              this.printForm.attentionTo,
              this.printForm.poNumber,
            ];
          })
          .then((data) => {
            this.partnerData = data;
          });
      }
    },
  },
};
</script>
<style scoped>
abbr {
  max-width: 150px;
  word-break: initial;
}

.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}

.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}

.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>